import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';

class Messages extends Component {
    componentDidMount() {
        this.props.dispatch(Action.get('Messages'));
    }

    hideMessage(e, messageId) {
        e.preventDefault();
        this.props.dispatch(Action.set('ViewedMessage', messageId));
    }

    render() {
        let {messages} = this.props;
        let rows = [];

        if (messages && messages.length > 0) {
            messages.map((message) => {
                rows.push(
                    <div className="alert alert-message" key={message.id}>
                        {message.content}
                        <a href="" className="close-alert">
                            <i className="fa fa-times" onClick={(e) => ::this.hideMessage(e, message.id)}></i>
                        </a>
                    </div>,
                );
            });
        } else {
            return false;
        }

        return <div>{rows}</div>;
    }
}

function mapStatesToProps(state) {
    return {messages: state.messagesData.messages.data};
}

export default connect(mapStatesToProps)(Messages);
